<template>
  <div id="child3">
    <div class="header1">
      <span style="font-size:14px" class="time-title">浏览时间：</span>
      <el-date-picker
        v-model="browseTime"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="——"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="timeChange"
      />
      <span style="font-size:14px" class="time-title">商品名称：</span>
      <el-input v-model="BrowseRecords.jsonobj.fstockName" placeholder="请输入内容" />
      <!-- <div class="stock-name" style="position:relative;">
        <el-select v-model="BrowseRecords.jsonobj.fstockId" filterable placeholder="请选择" allow-create default-first-option>
          <el-option
            v-for="(item, index) in BrowseRecords.select"
            :key="index + 'select'"
            :label="item.fStockName"
            :value="item.fStockID"
          />
        </el-select>
        <span class="el-icon-close" @click="BrowseRecords.jsonobj.fstockId = ''" />
      </div> -->
      <el-button type="primary" class="toBig" @click="uplist">查询</el-button>
      <div class="record">
        <el-button class="toBig" @click="allClear">清空</el-button>
        <el-button class="toBig" type="primary" @click="checkClear = !checkClear">{{ checkClear?'取消': '管理' }}
        </el-button>
      </div>
    </div>
    <div id="body1" v-loading="loading" class="body1">
      <el-timeline>
        <template v-for="(item, index) in BrowseRecords.list" v-if="item.show">
          <el-timeline-item :key="index + 'sd'" :timestamp="item.fCreateTime" placement="top">
            <div class="com-parant">
              <div
                v-for="(items, indexs) in item.browseStockList"
                v-if="items.show"
                :key="indexs + 'as'"
                class="combox"
                @click="toDetail(items)"
              >
                <el-checkbox v-show="checkClear" v-model="items.check" @change="checkChange" />
                <div class="imgbox">
                  <template v-if="items.fCover">
                    <img width="196px" height="196px" :src="items.fCover" alt>
                  </template>
                  <template v-else>
                    <img
                      style="object-fit: contain"
                      width="172px"
                      height="172px"
                      src="@/assets/images/stockImg.jpg"
                      alt
                    >
                  </template>
                  <div v-if="!items.FOperationMode" class="self-support">自营</div>
                </div>
                <div class="contentbox">
                  <div v-if="FPriceShow" class="price">
                    <template v-if="items.IsDirectoryPool">
                      <span
                        class="query"
                        style="font-size: 16px; font-weight: bold; color: #ec212d"
                      >{{ _stockPrice(items.fStockPrice,item.FTPriceDecimal) }}
                        <span v-if="items.fMeasurement">
                          /{{ items.fMeasurement }}
                        </span></span>
                      <span style="font-size:12px;color:#666;text-decoration: line-through;margin-left: 8px;">
                        ￥{{ _stockPrice(items.fPrice,item.FTPriceDecimal) }}
                        <span v-if="items.fMeasurement">
                          /{{ items.fMeasurement }}
                        </span>
                      </span>
                    </template>
                    <div v-else class="isDirectoryPool">
                      不在目录池
                    </div>
                  </div>
                  <div v-else id="noShowPrice">
                    <span>￥</span>价格不可见
                  </div>
                  <div class="title" :title="items.fStockName">
                    {{ items.fStockName }}
                  </div>
                  <div class="bianma" :title="items.FShortCode">
                    订货编码:
                    <div>{{ items.FShortCode | filterCode }}</div>
                    <i
                      v-show="items.FShortCode"
                      class="el-icon-document-copy"
                      @click.stop.prevent="copyClick(items.FShortCode)"
                    />
                  </div>
                  <div class="bianma" :title="items.FDemandStcokCode">
                    需方编码:
                    <div>{{ items.FDemandStcokCode | filterCode }}</div>
                    <i
                      v-show="items.FDemandStcokCode"
                      class="el-icon-document-copy"
                      @click.stop.prevent="copyClick(items.FDemandStcokCode)"
                    />
                  </div>

                  <div
                    style="
                font-size: 12px;
                margin-right: 9px;

                color: #666666;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
              "
                  >
                    <span style="line-height: 16px">
                      发货日：<span v-if="items.fDeliveryInfo" class="deliverData">{{
                        items.fDeliveryInfo
                      }}</span>
                    </span>
                    <span style="float: right">
                      <svg-icon style="margin-right: 5px" icon-class="address" />{{
                        assderFilt(items.fLevelName)
                      }}
                    </span>
                  </div>
                  <div class="ability">
                    <template v-if="items.IsDirectoryPool">
                      <div style="display: flex;justify-content: space-between;">
                        <div style="margin-right:8px;" class="ability-btn" @click.stop="collection(items)">
                          <span class="iconEnter"><svg-icon style="margin-right: 5px;" :icon-class="items.fCollectioned ? 'collection2' : 'collection'" /></span>
                          <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="collection1" /></span>
                          <span :class="items.fCollectioned ? '' : 'writeText'">{{ items.fCollectioned ? '已收藏' : '收藏' }}</span>
                        </div>
                        <div class="ability-btn" @click.stop="addCart(items)">
                          <span class="iconEnter"><svg-icon style="margin-right: 5px;" :icon-class="items.isAddCart ? 'cart' : 'cart2'" /></span>
                          <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="cart1" /></span>
                          <span :class="items.isAddCart ? '' : 'writeText'">{{ items.isAddCart ? '已加入购物车' : '加入购物车' }}</span>
                        </div>
                      </div>
                    </template>

                    <el-popover
                      v-else
                      placement="top-start"
                      trigger="hover"
                      width="160"
                    >
                      <div slot="reference" style="width:100%;" class="ability-btn">
                        <span class="iconEnter"><svg-icon style="margin-right: 5px;" icon-class="newPhone1" /></span>
                        <span class="iconHover"><svg-icon style="margin-right: 5px;" icon-class="newPhone2" /></span>
                        联系我们
                      </div>
                      <div>
                        <div>
                          <svg-icon style="margin-right: 5px;" icon-class="red-user" />
                          {{ $store.state.user | userName }}
                        </div>
                        <div>
                          <span class="iconEnter"><svg-icon style="margin-right: 5px;" icon-class="newPhone" /></span>
                          {{ $store.state.user | userPhone }}
                        </div>
                      </div>
                    </el-popover>

                  </div>
                </div>
              </div>
            </div>
          </el-timeline-item>
        </template>
      </el-timeline>
      <div
        id="user-child-below"
        class="below"
        :style="bleowFixed?{'width':userWidth+'px','position': 'fixed','bottom': 0}:''"
      >
        <div v-show="checkClear">
          <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="checkSelect">全选</el-checkbox>
          <el-button type="primary" @click="delSelect">删除</el-button>
        </div>
      </div>
    </div>

    <el-dialog
      title="清空"
      :visible.sync="allDeletedialog"
      width="20%"
      height="10%"
      center
      :before-close="handleClose"
    >
      <img src="@/assets/images/abc.png" style="text-align: center">
      <span style="display: block">{{ allDeletedialogType?"确定要清空全部浏览记录？": "确定要删除已选浏览记录？" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="allDeletedialog = false">取 消</el-button>
        <el-button type="primary" @click="onconfirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import quest from '../../api/user'
import request from '@/utils/request.js'
export default {
  filters: {
    filterCode(val) {
      if (val) return val.slice(0, 9)
    },
    userPhone(val = {}) {
      if (val.customer) {
        let leftstr = ''; let rightstr = ''
        if (val.customer.name) {
          leftstr = val.customer.name + ' '
        }
        if (val.customer.pho) {
          const str = String(val.customer.pho)
          rightstr = str.slice(0, 3) + ' ' + str.slice(3, 7) + ' ' + str.slice(7)
        }
        return rightstr
      } else {
        return ''
      }
    },
    userName(val = {}) {
      if (val.customer) {
        let leftstr = ''; let rightstr = ''
        if (val.customer.name) {
          leftstr = val.customer.name + ' '
        }
        if (val.customer.pho) {
          const str = String(val.customer.pho)
          rightstr = str.slice(0, 3) + ' ' + str.slice(3, 7) + ' ' + str.slice(7)
        }
        return leftstr
      } else {
        return ''
      }
    }
  },
  props: {
    // list: {
    //   type: [Array, Object],
    //   default: function() {
    //     return []
    //   }
    // },
    // select: {
    //   type: [Array, Object],
    //   default: function() {
    //     return []
    //   }
    // },
    // model: {
    //   type: Object,
    //   default: function() {
    //     return {}
    //   }
    // }
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      checkClear: false, // 多选删除浏览记录
      messgeForm: {
        begintime: '',
        endtime: ''
      },
      allDeletedialog: false, // 清空全部浏览记录弹窗
      allDeletedialogType: 0, // 1=全选；0=已选删除
      flgScrl: false,
      pageSize: 0,
      endPage: -1,
      userWidth: 0,
      bleowFixed: true,
      FPriceShow: 0,
      browseTime: [],
      BrowseRecords: {
        pageNo: 1,
        pageSize: 30,
        total: 0,
        jsonobj: {},
        list: [],
        select: []
      }, // 浏览记录分页
      BrowseRecordsMaxNum: 0,
      endSub: -1,
      propNum: 0,
      propMaxNum: 30,
      loading: false,
      screenWidth: document.body.clientWidth
    }
  },
  watch: {
    'BrowseRecords.list'() {
      this.checkAllfilter()
    },
    propNum() {
      this.pageSize = this.propNum
      this.endPage = this.endSub
    },
    screenWidth() {
      this.userWidth = document.getElementById('body1').offsetWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      const domWidth = document.getElementById('body1').offsetWidth / 266
      const domHeight = window.innerHeight / 350
      this.BrowseRecordsMaxNum = Math.ceil(domWidth) * Math.ceil(domHeight + 1) // 每屏最大数量
    })
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    // const footerHeight = document.querySelector('.el-footer .ng-promise-box')
    const footerBleow = document.getElementById('user-child-below')
    onscroll = (e) => {
      if (this.flgScrl) return
      const top = window.scrollY + window.innerHeight
      const maxtop = document.body.scrollHeight - 800

      //   console.log(top, maxtop)
      if (top > maxtop) {
        this.flgScrl = true
        this.nextHistory()
        this.flgScrl = false
        // console.log('加载', this.endPage)
      }
      //   console.log(footerHeight,footerBleow)
      //   console.log(top, document.body.scrollHeight, footerHeight.offsetHeight, footerBleow.offsetHeight)
      //   - footerHeight.offsetHeight
      if (top > document.body.scrollHeight - footerBleow.offsetHeight) {
        // console.log("触发")
        this.bleowFixed = false
      } else {
        this.bleowFixed = true
      }
      // console.log(top, maxtop)
    }
    this.userWidth = document.getElementById('body1').offsetWidth
    window.onresize = () => {
      window.onscroll.call(this)
      this.screenWidth = document.body.clientWidth
    }
    this.uplist()
  },
  methods: {
    _stockPrice(val,FTPriceDecimal) {
      let price = val||0;
      console.log(val)
      if(FTPriceDecimal!=undefined||FTPriceDecimal!=null)price = val.toFixed(FTPriceDecimal);
      else price=val.toFixed(2);
      price=String(parseFloat(price||0));
      return price
    },
    addCart(item) {
      if (!localStorage.getItem('userInfo')) return this.$router.push({ path: '/login/login' })
      const jsonobj = {
        'shoppingCartList': [{
          'fstockName': item.fStockName,
          'fmallstoreStockId': item.fmallstoreStockId,
          'fQuanty': 1
        }]
      }
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(jsonobj))
      request({
        url: '/mall/stockmanage/mallstorestock/addShoppingCart',
        method: 'post',
        data: params
      })
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.$set(item, 'isAddCart', 1)
            this.$parent.$parent.$parent.$refs.rightNav.getComput()
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    collection(item) {
      if (!localStorage.getItem('userInfo')) return this.$router.push({ path: '/login/login' })
      const operationType = item.fCollectioned ? 3 : 1
      const url = `/mall/stockmanage/mallstorestock/collectStock/${item.fmallstoreStockId}/0/${operationType}`
      request({
        url,
        method: 'get'
      })
        .then(res => {
          if (res.result) {
            item.fCollectioned = item.fCollectioned ? 0 : 1
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    copyClick(val = '') {
      if (!val) return
      const input = document.createElement('input')
      // 创建input对象
      // const testDiv = document.querySelector('.testDiv')
      // 获取需要复制文字的容器
      input.value = val
      // 设置复制内容
      document.body.appendChild(input)
      // 添加临时实例
      input.select()
      // 选择实例内容
      document.execCommand('Copy')
      // 执行复制
      document.body.removeChild(input)
      // 删除临时实例
      this.$message.success('复制成功！')
    },
    changeData() {
      this.$nextTick(() => {
        const that = this
        window.onscroll.call(that)
      })

      this.pageSize = this.propNum
      this.endPage = this.endSub
    },
    nextHistory() {
    //   console.log(this.propNum, this.endPage, this.propMaxNum)
      if (this.propNum < this.propMaxNum || !this.BrowseRecords.list[this.endPage]) return
      let num = 0
      const maxnum = this.propMaxNum
      for (let sub = this.endPage; sub < this.BrowseRecords.list.length; sub++) {
        if (num >= maxnum) {
          this.endPage = sub
          break
        }
        const subitem = this.BrowseRecords.list[sub]

        this.BrowseRecords.list[sub].browseStockList.forEach(subitems => {
          if (num < maxnum && !subitems.show) {
            this.$set(subitems, 'show', true)
            num++
          }
        })
        this.$set(subitem, 'show', true)
        subitem.show = true
      }
    },
    toDetail(item) {
      if (this.checkClear) return
      this.$router.push({
        path: '/store/details',
        query: {
          mallstorestockFId: item.fmallstoreStockId,
          shopid: item.fMallStoreId
        }
      })
    },
    assderFilt(item) {
      const asderr = item.split('\\')
      let index = asderr.find(items => {
        if (items) {
          return String(items).search('市') > -1
        } else {
          return false
        }
      })
      if (!index) {
        index = asderr[asderr.length - 1]
      }
      return index
    },
    delSelect() {
      if (!this.BrowseRecords.list.length) {
        this.$message({
          showClose: true,
          message: '无浏览记录',
          type: 'warning'
        })
        return
      }
      this.allDeletedialogType = 0
      this.allDeletedialog = true
    },
    checkChange() {
      this.$forceUpdate()
      this.checkAllfilter()
    },
    checkSelect(val) {
      if (val) {
        this.BrowseRecords.list.forEach(item => {
          if (item.browseStockList) {
            item.browseStockList.forEach(items => {
              items.check = true
            })
          }
        })
      } else {
        this.BrowseRecords.list.forEach(item => {
          if (item.browseStockList) {
            item.browseStockList.forEach(items => {
              items.check = false
            })
          }
        })
      }
      this.checkAllfilter()
    },
    picrFilter(item) {
      const arr = [
        item.fNoAPPrice,
        item.fOnMAPPrice,
        item.fTwMAPPrice,
        item.fThMAPPrice,
        item.fFoMAPPrice,
        item.fFiMAPPrice
      ]
      const showPrice = arr[Number(item.fOutDayLimit)]
      const showSpliPrice = showPrice.toString().split('.')
      const str = !isNaN(Number(showPrice))
        ? Number(showPrice).toFixed(3)
        : '0.00'
      const index = str.indexOf('.')
      return str.slice(0, index + 3)
    },
    FixedTo(num) {
      const str = !isNaN(Number(num)) ? Number(num).toFixed(3) : '0.00'
      const index = str.indexOf('.')
      return str.slice(0, index + 3)
    },
    timeChange(val) {
      this.BrowseRecords.jsonobj.startTime = val ? val[0] : ''
      this.BrowseRecords.jsonobj.endTime = val ? val[1] : ''
    },
    uplist() {
      if (this.loading) return
      this.loading = true
      const json = JSON.parse(JSON.stringify(this.BrowseRecords.jsonobj))
      //   if (typeof json.fstockId === 'string') {
      //     json.fstockName = json.fstockId
      //     json.fstockId = ''
      //   } else {
      //     json.fstockId = json.fstockId
      //     json.fstockName = ''
      //   }
      //   console.log(json)
      const params = `?jsonobj=${encodeURI(
        JSON.stringify(json)
      )}&pageSize=2000&pageNo=1`

      quest.RecordsSear({
        params
      }).then(res => {
        if (res.result) {
          this.BrowseRecords.list = res.data
          const select = []
          const AllList = []
          res.data.forEach(item => {
            if (item.browseStockList) {
              item.browseStockList.forEach(items => {
                items.check = false
                AllList.push(items)
                const sel =
                                        select.findIndex(
                                          itemss => itemss.fStockID == items.fStockID
                                        ) < 0
                if (sel) {
                  select.push(items)
                }
              })
            }
          })

          let num = 0
          const maxnum = this.propMaxNum

          for (let sub = 0; sub < this.BrowseRecords.list.length; sub++) {
            if (num >= maxnum) {
              this.endSub = sub - 1
              break
            }
            const subitem = this.BrowseRecords.list[sub]
            this.BrowseRecords.list[sub].browseStockList.forEach(subitems => {
              if (num < maxnum && !subitems.show) {
                subitems.show = true
                num++
              }
            })
            subitem.show = true
          }
          //   this.BrowseRecordsNum = num
          this.propNum = num
          // console.log(this.BrowseRecords.list)
          // this.BrowseRecords.select = select;
          this.$set(this.BrowseRecords, 'select', select)
          //   if (fn) fn(AllList)
          const that = this
          this.changeData.call(that)
        }
        this.loading = false
      })
        .catch(() => {
          this.loading = false
        })
    },
    allClear() {
      if (!this.BrowseRecords.list.length) {
        this.$message({
          showClose: true,
          message: '无浏览记录',
          type: 'warning'
        })
        return
      }
      this.allDeletedialogType = 1
      this.allDeletedialog = true
    },
    ShopUp(shop) {
      const data = [{
        fstockName: shop.fStockName,
        fmallstoreStockId: shop.fmallstoreStockId,
        fQuanty: 1
      }]
      this.$emit('shop-up', data)
    },
    handleClose() {
      this.allDeletedialog = false
    },
    initUser() {
      quest.userInfo().then(res => {
        if (res.result) {
          this.info = res.data
          this.StockCollectTotal = this.info.stockCollect || 0
          this.StoreCollectTotal = this.info.storeCollect || 0
          this.BrowseRecordsTotal = this.info.browseRecords || 0
        }
      })
    },
    // 清空浏览记录
    onconfirm() {
      if (this.allDeletedialogType) {
        // 清除
        quest.delBrowseRecords(0).then(res => {
          this.allDeletedialog = false
          this.initUser()
          this.uplist()
        })
      } else {
        // 手选
        const checkAlls = []
        this.BrowseRecords.list.forEach(item => {
          if (item.browseStockList) {
            item.browseStockList.forEach(items => {
              checkAlls.push(items)
            })
          }
        })
        const nextA = checkAlls
          .filter(item => item.check)
          .map(item => item.fBrowseId)
          .join(',')
        quest.delBrowseRecords(nextA).then(res => {
          this.allDeletedialog = false
          this.initUser()
          this.uplist()
        })
      }
    },
    checkAllfilter() {
      const checkAlls = []
      this.BrowseRecords.list.forEach(item => {
        if (item.browseStockList) {
          item.browseStockList.forEach(items => {
            checkAlls.push(items)
          })
        }
      })
      const next = checkAlls.find(item => !item.check)
      const nextA = checkAlls.filter(item => item.check)
      if (!next && nextA.length) {
        this.isIndeterminate = false
        this.checkAll = true
      } else if (nextA.length) {
        this.isIndeterminate = true
        this.checkAll = false
      } else {
        this.checkAll = false
        this.isIndeterminate = false
      }
    }
  }
}
</script>

<style lang="scss">
    #child3 {

        .toBig {
            width: 69px;
            height: 36px;
        }

        .header1 {
            display: flex;
            align-items: center;
            padding-left: 10px;
            padding-right: 8px;
            height: 64px !important;
            background: #fff !important;
            box-shadow: 0px 0px 10px 0px rgba(236, 33, 45, 0.1);
            margin-bottom: 18px;

            .el-date-editor .el-range-separator {
                line-height: 26px;
            }

            .el-range-editor.el-input__inner,
            .el-input__inner {
                height: 36px;
            }

            .el-date-editor {
                width: 16%;
                margin-right: 24px;
            }

            .el-input {
                width: 14%;
                margin-right: 24px;
            }

            // .stock-name {
            //     width: 14%;
            //     margin-right: 24px;
            //     .el-icon-close {
            //         position: absolute;
            //         top: 50%;
            //         margin-top: -7px;
            //         right: 27px;
            //         cursor: pointer;
            //         color: #c0c4cc;
            //       }
            // }

            .time {
                display: flex;
                flex-direction: row;

                &-title {
                    font-size: 14px;
                    font-weight: 400;
                    color: #666;
                    height: 36px;
                    white-space: nowrap;
                    line-height: 36px;
                    margin-right: 7px;
                }

                .timebox {
                    display: flex;

                    .begintime {
                        .el-date-editor.el-input {
                            width: 120px !important;
                            height: 36px;
                        }

                        .el-input--prefix .el-input__inner {
                            width: 120px;
                            height: 36px;
                            padding-left: 14px;
                            background: #ffffff;
                            border: 1px solid #d2d2d2;
                        }

                        .el-date-editor {
                            .el-input__prefix {
                                left: initial;
                                right: 2px;

                                .el-input__icon {
                                    line-height: 36px;
                                }
                            }
                        }
                    }

                    .line {
                        width: 9px;
                        height: 1px;
                        margin: 10px;
                        margin-top: 18px;
                        background-color: #999999;
                    }

                    .endtime {
                        .el-date-editor.el-input {
                            width: 120px !important;
                            height: 36px;
                        }

                        .el-input--prefix .el-input__inner {
                            width: 120px;
                            height: 36px;
                            padding-left: 14px;
                            background: #ffffff;
                            border: 1px solid #d2d2d2;
                        }

                        .el-date-editor {
                            .el-input__prefix {
                                left: initial;
                                right: 2px;

                                .el-input__icon {
                                    line-height: 36px;
                                }
                            }
                        }
                    }
                }
            }

            .follow {
                white-space: nowrap;
                height: 36px;
                margin-left: 25px;

                .demo-form-inline {
                    display: flex;

                    .el-form-item:first-child {
                        display: flex;
                        margin-bottom: 0px;

                        label {
                            font-size: 12px;
                            line-height: 36px;
                            font-weight: 400;
                            font-family: SimSun;
                            color: #333333;
                        }

                        .el-form-item__content {
                            flex: 1;
                            width: 150px;
                            height: 28px;
                            line-height: 28px;
                        }

                        //   .el-icon-close {
                        //     position: absolute;
                        //     top: 50%;
                        //     margin-top: -7px;
                        //     right: 27px;
                        //     cursor: pointer;
                        //     color: #c0c4cc;
                        //   }
                    }

                    .el-form-item:last-child {
                        margin-bottom: 0px;

                        button {
                            padding: 6px 11.5px;
                            margin-left: 22px;
                        }

                        .el-form-item__content {
                            height: 28px;
                            line-height: 28px;
                        }
                    }
                }
            }

            .record {
                margin-left: auto;

                button {
                    padding: 6px 11.5px;
                }
            }
        }

        .body1 {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            // margin: 20px 20px;
            min-height: calc(100vh - 123px);

            .el-timeline-item__timestamp.is-top {
                padding: 0;
                margin-bottom: 12px;
                font-size: 14px;
                color: #666666;
            }

            .el-timeline-item {
                padding: 0;
            }

            ul {
                li {
                    .com-parant {
                        display: flex;
                        flex-wrap: wrap;
                        margin-left: -12px;

                        //   margin-left: -16px;
                    }

                    .el-timeline-item__tail {
                        display: none;
                    }

                    .el-timeline-item__wrapper {
                        padding-left: 0;
                    }

                    div:nth-child(2) {
                        //   background-color: #fff;
                    }

                    div {
                        //   background-color: #fff;

                        div {
                            position: relative;

                            label {
                                position: absolute;
                                right: -1px;
                                top: -2px;
                            }

                            .combox {
                                width: 254px;
                                height: 448px;
                                padding: 12px;
                                box-sizing: border-box;
                                background: #ffffff;
                                border: 1px solid #d2d2d2;
                                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
                                margin-left: 12.5px;
                                margin-bottom: 12px;

                                .imgbox {
                                    position: relative;

                                    img {
                                        width: 227px;
                                        height: 227px;
                                    }

                                    .self-support {
                                        position: absolute;
                                        right: 0;
                                        top: 0;
                                        width: 36px;
                                        height: 18px;
                                        border-radius: 2px;
                                        line-height: 18px;
                                        text-align: center;
                                        background: #EC212D;
                                        font-size: 12px;
                                        color: #fff;
                                    }
                                }

                                .contentbox {
                                    position: relative;

                                    .isDirectoryPool {
                                        height: 24px;
                                        line-height: 24px;
                                        padding-left: 10px;
                                        background: #fbd2d5;
                                        font-size: 14px;
                                        color: #EC212D;
                                        font-weight: bold;
                                    }

                                    .ability {
                                        margin-top: 12px;
                                        .ability-btn {
                                            caret-color: rgba(0,0,0,0);
                                            cursor: pointer;
                                            display: inline-block;
                                            width: 110px;
                                            height: 32px;
                                            line-height: 32px;
                                            text-align: center;
                                            border: 1px solid #E8E8E8;
                                            border-radius: 4px;
                                            font-size: 12px;
                                            color: #EC212D;
                                            .writeText {
                                                color: #333;
                                            }
                                            .iconHover {
                                                display: none;
                                            }
                                        }
                                        .ability-btn:hover {
                                            background: #EC212D;
                                            border-color: #EC212D;
                                            color: #fff;
                                            .writeText {
                                                color: #fff;
                                            }
                                            .iconEnter {
                                                display: none;
                                            }
                                            .iconHover {
                                                display: inline-block;
                                            }
                                        }
                                    }

                                    .isshoped {
                                        background: #fbd2d5;
                                        font-size: 12px;
                                        font-weight: bold;
                                        color: #ec212d;
                                        float: right;
                                        width: 64px;
                                        height: 22px;
                                        line-height: 22px;
                                        text-align: center;
                                    }

                                    .bianma {
                                        font-size: 12px;
                                        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                                        font-weight: 400;
                                        color: #666666;
                                        line-height: 22px;

                                        div {
                                            display: inline-block;
                                            max-width: 150px;
                                            overflow: hidden;
                                            text-overflow: ellipsis;

                                            vertical-align: bottom;
                                        }

                                        i {
                                            cursor: pointer;
                                            margin-left: 6px;
                                        }
                                    }

                                    #noShowPrice {
                                        position: relative;
                                        top: 3px;
                                        width: 100%;
                                        text-align: left;
                                        padding-left: 10px;

                                        .shopcar {
                                            top: 5px;
                                        }
                                    }

                                    .storeName {
                                        // margin-left: 9px;
                                        margin: 8px 0px 0;
                                        font-size: 14px;
                                        color: #000;
                                        //   margin-top: 8px;
                                        overflow: hidden;
                                        /*溢出隐藏*/
                                        white-space: nowrap;
                                        /*规定文本不进行换行*/
                                        text-overflow: ellipsis;

                                        /*当对象内文本溢出时显示省略标记（...）*/
                                        .deliverData {
                                            font-size: 12px;
                                            color: #fff;
                                            background: #ff8e50;
                                            padding: 0 5px;
                                            font-family: Microsoft YaHei;
                                            line-height: 16px;
                                            border-radius: 5px;
                                        }
                                    }

                                    .deliverData {
                                        font-size: 12px;
                                        color: #fff;
                                        background: #ff8e50;
                                        padding: 2px 5px;
                                        font-family: Microsoft YaHei;
                                        line-height: 16px;
                                    }

                                    .showtime {
                                        display: flex;
                                        justify-content: space-between;
                                        margin-top: 12px;

                                        .left {
                                            width: 115px;
                                            height: 32px;
                                            line-height: 32px;
                                            text-align: center;
                                            font-size: 12px;
                                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                                            font-weight: 400;
                                            color: #ec212d;
                                            border-radius: 4px 4px 4px 4px;
                                            border: 1px solid #e8e8e8;
                                            box-sizing: border-box;

                                            i {
                                                font-size: 16px;
                                                vertical-align: middle;
                                            }
                                        }

                                        .right {
                                            width: 115px;
                                            height: 32px;
                                            line-height: 32px;
                                            text-align: center;
                                            font-size: 12px;
                                            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                                            font-weight: 400;
                                            color: #333333;
                                            border-radius: 4px 4px 4px 4px;
                                            border: 1px solid #e8e8e8;
                                            display: flex;
                                            box-sizing: border-box;
                                            justify-content: center;
                                            cursor: pointer;

                                            .svg-icon {
                                                margin: auto 0;
                                                margin-right: 7px;
                                            }
                                        }
                                    }

                                    .title {
                                        height: 37px;
                                        margin-left: 0px;
                                        margin-bottom: 9px;
                                        width: 230px;
                                        //   text-overflow: ellipsis;
                                        //   white-space: nowrap;
                                        font-size: 14px;
                                        //   font-family: SimSun;
                                        font-weight: 400;
                                        color: #000;
                                        display: -webkit-box;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        word-break: break-all;
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 2; //此处为行数，可以改为任意数字
                                    }

                                    .model {
                                        margin-left: 9px;
                                        margin-top: 7px;
                                        font-size: 14px;
                                        font-family: SimSun;
                                        font-weight: 400;
                                        color: #999999;
                                    }

                                    .price {
                                        // margin-top: 8px;
                                        padding: 10px 0;
                                        margin-left: 0px;
                                        font-size: 12px;
                                        font-family: Microsoft YaHei;
                                        font-weight: 400;
                                        color: #ec212d;

                                        .a {
                                            display: inline-block;
                                            transform: scale(0.83, 0.83);
                                        }

                                        .b {
                                            font-size: 14px;
                                        }
                                    }

                                    .shopcar {
                                        font-size: 16px;
                                        position: absolute;
                                        right: 10px;
                                        top: 2px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .below {
            z-index: 999;

            div {
                display: flex;
                justify-content: space-between;
                background: #ffffff;
                border: 1px solid #cdcdcd;
                border-radius: 2px;

                button {
                    width: 180px;
                    height: 46px;
                    background: #ec212d;
                    border-radius: 2px;
                }

                label {
                    display: flex;
                    align-items: center;
                    margin-left: 10px;
                }
            }
        }

        .el-dialog {
            div:nth-child(2) {
                text-align: center;

                span {
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                }
            }

            div:last-child {
                button:first-child {
                    width: 100px;
                    padding: 8px 20px;
                    border: 1px solid #ec212d;
                    border-radius: 0;

                    span {
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #ec212d;
                    }
                }

                button:last-child {
                    width: 100px;
                    padding: 8px 20px;
                    border: 1px solid #ec212d;
                    border-radius: 0;

                    span {
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #ffffff;
                    }
                }
            }
        }
    }
</style>
